import { Currency, FormattedNumber } from '@sushiswap/ui'
import React, { useMemo } from 'react'
import { formatUSD } from 'sushi'
import { type EvmAddress, type EvmChainId, EvmToken } from 'sushi/evm'
import { PortfolioInfoRow } from '../portfolio-info-row'
import type { PortfolioToken } from './use-portfolio-balances'

const KATANA_CHAIN_ID = 747474 as EvmChainId

function getCurrency(token: PortfolioToken) {
  return new EvmToken({
    chainId: KATANA_CHAIN_ID,
    address: token.token_address as EvmAddress,
    decimals: token.decimals,
    symbol: token.symbol,
    name: token.name,
  })
}

export function PortfolioTokensList({
  tokens: _tokens,
}: { tokens: PortfolioToken[] }) {
  const tokens = useMemo(
    () =>
      _tokens.map((token) => ({
        currency: getCurrency(token),
        token,
      })),
    [_tokens],
  )

  return (
    <div className="overflow-y-auto h-full cursor-default">
      {tokens.map(({ currency, token }) => (
        <PortfolioInfoRow
          key={token.token_address}
          chainId={KATANA_CHAIN_ID}
          icon={<Currency.Icon currency={currency} width={28} height={28} />}
          leftContent={
            <React.Fragment>
              <div className="text-sm font-medium overflow-hidden overflow-ellipsis">
                {token.name ?? token.symbol}
              </div>
              <div className="text-xs text-muted-foreground overflow-hidden overflow-ellipsis">
                <FormattedNumber number={token.balance.toString()} />{' '}
                {token.symbol}
              </div>
            </React.Fragment>
          }
          rightContent={
            <div className="text-sm font-medium overflow-hidden overflow-ellipsis">
              {formatUSD(token.value_usd ?? 0)}
            </div>
          }
        />
      ))}
    </div>
  )
}
